import React, { Component } from 'react';
import moment from 'moment';

import { Table, Popconfirm } from 'antd';

class CheckingParkingTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {}
  }  

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  render() {    
    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Typ oprávnění',
      dataIndex: 'type',
      key: 'type',
      filters: [
        { text: 'PA - Parkovací automat', value: 'PA' },
        { text: 'MPA - Mobilní platební aplikace', value: 'MPA' },        
        { text: 'EPO - Evidence parkovacích opravnění', value: 'EPO' }
      ],
      width: 150,
      filteredValue: filteredInfo.type || null,
      onFilter: (value, record) => { return (record.type == value) ? true : false }
    }, {
      title: 'Reg. značka',
      dataIndex: 'plate',
      key: 'plate', 
    }, {
      title: 'Platnost od',
      dataIndex: 'startParking',
      key: 'startParking',
      render: (text, record) => (        
        <span>{text ? moment(text).format('LLLL') : null}</span>
      ),
      sorter: (a, b) => {
        return (a.startParking < b.startParking) ? -1 : ((a.startParking > b.startParking) ? 1 : 0);
      }
    }, {
      title: 'Platnost do',
      dataIndex: 'endParking',
      key: 'endParking',    
      render: (text, record) => (        
        <span>{text ? moment(text).format('LLLL') : null}</span>
      ),
      defaultSortOrder: 'ascend',
      sorter: (a, b) => {
        return (a.startParking < b.startParking) ? -1 : ((a.startParking > b.startParking) ? 1 : 0);
      }  
    }];

    return (    
      <Table         
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={columns} 
        dataSource={this.props.data} 
        style={{border: '0px'}} 
        onChange={this.handleChange} 
        pagination={{
          showSizeChanger: true,
          defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
            ? parseInt(localStorage.getItem('table_pageSize'))
            : 10,
          onShowSizeChange: (current, size) => {
            localStorage.setItem('table_pageSize', size);
          }
        }}
        locale={{ emptyText: 'Žádné parkovací oprávnění' }} />
    );
  }
}

export default CheckingParkingTable;


// WEBPACK FOOTER //
// ./src/components/CheckingParkingTable.js